import React from 'react';
import GroomingBookingCard from './GroomingBookingCard';

const GroomingBookingsDisplay = ({
    todayBookings,
    upcomingBookings,
    loading,
    onEdit,
    onDelete,
    onStatusUpdate,
    onPaymentUpdate
}) => {
    const formatDateHeader = (dateString) => {
        if (!dateString) return 'No date';
        
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return 'Invalid date';
            
            return date.toLocaleDateString('es-ES', {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            });
        } catch (error) {
            return 'Invalid date';
        }
    };

    const groomingPriority = (b) => {
        if (b.status !== 'completed') return 0;
        if (b.paymentStatus === 'pending') return 1;
        return 2;
    };

    const sortBookings = (a, b) => {
        const diff = groomingPriority(a) - groomingPriority(b);
        if (diff !== 0) return diff;
        return new Date(a.appointmentDate) - new Date(b.appointmentDate);
    };

    // Group upcoming bookings by date
    const groupBookingsByDate = (bookings) => {
        const grouped = {};
        
        bookings.forEach(booking => {
            const date = new Date(booking.appointmentDate);
            const dateKey = date.toDateString();
            
            if (!grouped[dateKey]) {
                grouped[dateKey] = [];
            }
            grouped[dateKey].push(booking);
        });
        
        // Sort each group by priority then time
        Object.keys(grouped).forEach(dateKey => {
            grouped[dateKey].sort(sortBookings);
        });
        
        return grouped;
    };

    const upcomingGrouped = groupBookingsByDate(upcomingBookings);
    const sortedUpcomingDates = Object.keys(upcomingGrouped).sort((a, b) =>
        new Date(a) - new Date(b)
    );

    // Filter to appointments that are actually today in local time (backend may use UTC)
    const localTodayStr = new Date().toDateString();
    const localTodayBookings = todayBookings.filter(b =>
        new Date(b.appointmentDate).toDateString() === localTodayStr
    );

    if (loading) {
        return <div className="loading">Cargando citas de estética...</div>;
    }

    return (
        <div className="grooming-bookings-display">
            {/* Today's Bookings */}
            <div className="bookings-section today-section">
                <h2>🗓️ Citas de estética de hoy</h2>
                <p className="section-subtitle">{formatDateHeader(new Date())}</p>
                
                {localTodayBookings.length === 0 ? (
                    <div className="no-bookings">
                        <p>No hay citas de estética programadas para hoy.</p>
                        <p>🎉 ¡Disfruta el día tranquilo!</p>
                    </div>
                ) : (
                    <div className="bookings-grid">
                        {localTodayBookings
                            .slice()
                            .sort(sortBookings)
                            .map(booking => (
                                <GroomingBookingCard
                                    key={booking._id}
                                    booking={booking}
                                    onEdit={onEdit}
                                    onDelete={onDelete}
                                    onStatusUpdate={onStatusUpdate}
                                    onPaymentUpdate={onPaymentUpdate}
                                />
                            ))}
                    </div>
                )}
            </div>

            {/* Upcoming Bookings */}
            <div className="bookings-section upcoming-section">
                <h2>📅 Próximas citas de estética</h2>
                <p className="section-subtitle">Próximos 4 días</p>

                {upcomingBookings.length === 0 ? (
                    <div className="no-bookings">
                        <p>No hay citas de estética en los próximos 4 días.</p>
                        <p>📝 ¡Programa citas para mantener el negocio activo!</p>
                    </div>
                ) : (
                    <div className="upcoming-bookings">
                        {sortedUpcomingDates.map(dateKey => {
                            const bookingsForDate = upcomingGrouped[dateKey];
                            const date = new Date(dateKey);
                            
                            return (
                                <div key={dateKey} className="date-group">
                                    <h3 className="date-header">
                                        {formatDateHeader(date)}
                                        <span className="booking-count">
                                            ({bookingsForDate.length} cita{bookingsForDate.length !== 1 ? 's' : ''})
                                        </span>
                                    </h3>
                                    <div className="bookings-grid">
                                        {bookingsForDate.map(booking => (
                                            <GroomingBookingCard
                                                key={booking._id}
                                                booking={booking}
                                                onEdit={onEdit}
                                                onDelete={onDelete}
                                                onStatusUpdate={onStatusUpdate}
                                            />
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default GroomingBookingsDisplay;